import  footerComponent from './header.vue'

const  vheader={
  install:function (Vue) {
    Vue.component('v-header',footerComponent)
  }
}

export  default vheader;



// WEBPACK FOOTER //
// ./src/components/header/header.js